import React from 'react';
import ReactDOM from 'react-dom/client';
import { GlobalStyle } from 'govuk-react';
import FlexiBusMap from './FlexiBusMap';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <FlexiBusMap />
  </React.StrictMode>
);